import { render } from "./ListadoPagosPage.vue?vue&type=template&id=2771198a&scoped=true"
import script from "./ListadoPagosPage.vue?vue&type=script&lang=js"
export * from "./ListadoPagosPage.vue?vue&type=script&lang=js"

import "./ListadoPagosPage.vue?vue&type=style&index=0&id=2771198a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2771198a"]])

export default __exports__